import React, { FC } from 'react';

import { Button } from 'antd';

import { AnchorButtonProps, NativeButtonProps } from 'antd/lib/button/button';
import { clsx } from 'clsx';

interface ButtonProps extends Partial<AnchorButtonProps & NativeButtonProps> {}

const CentinelButton: FC<ButtonProps> = ({ children, ...props }) => {
  return (
    <Button
      {...props}
      className={clsx(
        `block whitespace-normal max-w-max h-auto py-2 text-blue font-bold border-cyan border-2 w-full min-w-[100%] m-auto ${props.className}`,
        {
          'border-none bg-greyShade': props.disabled,
          'hover:bg-cyan hover:text-blue ': !props.disabled,
        },
      )}
    >
      {children}
    </Button>
  );
};

export default CentinelButton;
